import apiClient from "./apiClient";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

export async function signDocument(token: string, fileId: any, reportId: any, cms: any) {
    try {
        const data: any = {
            cms: cms,
            fileId: fileId,
            reportId: reportId,
        };
        const response = await apiClient.post<any>(
            `${BASE_URL}/api/v1/sign/document`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                responseType: 'blob'
            }
        );

        const contentDisposition = response.headers['content-disposition'];
        let fileName = 'downloaded_file.pdf'; // Значение по умолчанию

        if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
            if (fileNameMatch && fileNameMatch[1]) {
                fileName = fileNameMatch[1];
            }
        }

        const blob = new Blob([response.data]);

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
    } catch (error) {
        console.error("Error on download:", error);
        throw error;
    }
}